const SHARE_PRESERVED_PARAMS = ["stats", "sort"]

const buildQueryString = params => {
  const keys = Object.keys(params)
  if (!keys.length) return ""
  return (
    "?" +
    keys
      .map(
        key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join("&")
  )
}

const toQueryString = params => {
  return buildQueryString(params)
}

const getParamsFromUrl = location => {
  // returns object of params from current url
  var search = location.search.substring(1)

  if (search === "") {
    return {}
  }

  return JSON.parse(
    '{"' +
      decodeURI(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  )
}

/** Route path only: leading slash, trailing slash for pages, collapses slashes. */
function normalizeCanonicalPath(routePath) {
  if (!routePath || typeof routePath !== "string") {
    return ""
  }
  let s = routePath.trim()
  if (!s) return ""
  if (!s.startsWith("/")) {
    s = `/${s}`
  }
  s = s.replace(/\/+/g, "/")
  if (!s.endsWith("/")) {
    s = `${s}/`
  }
  return s
}

/** Prefix site origin for bundled relative paths (e.g. OG images); preserves full http(s) URLs. */
function absoluteAssetUrl(baseSiteUrl, ref) {
  if (!ref) return ""
  const stringRef = typeof ref === "string" ? ref : String(ref)
  const s = stringRef.trim()
  if (/^https?:\/\//i.test(s)) {
    return s
  }
  const base = (baseSiteUrl || "https://thehiveindex.com").replace(/\/$/, "")
  const pathPart = s.startsWith("/") ? s : `/${s}`
  return `${base}${pathPart}`
}

function getPreservedShareParams(location) {
  const current = getParamsFromUrl(location)
  const preserved = {}
  SHARE_PRESERVED_PARAMS.forEach(key => {
    if (current[key]) preserved[key] = current[key]
  })
  return preserved
}

function buildPageUrlWithParams(baseUrl, location, extraParams = {}) {
  return (
    baseUrl +
    buildQueryString({ ...getPreservedShareParams(location), ...extraParams })
  )
}

export {
  toQueryString,
  buildQueryString,
  getParamsFromUrl,
  getPreservedShareParams,
  buildPageUrlWithParams,
  normalizeCanonicalPath,
  absoluteAssetUrl,
}
